import {
  ReportSummary,
  BacteriaAttention,
  BacteriaAttentionAction,
} from '@snapi/types';

const pick = (summary: ReportSummary): BacteriaAttention[] => {
  const attention: BacteriaAttention[] = summary.keyBacteria.bacteria
  const disruptive = summary.disruptive.bacteria.filter(
    ({ name }) => !attention.some((b) => b.name === name)
  );

  attention.push(...disruptive);

 Object.keys(summary.condition).forEach((condition) => {
    const conditonBacteria = summary.condition[condition];
    // const withoutAttention = conditonBacteria.filter(
    //   ({ name }) => !attention.some((b) => b.name === name)
    // );
    // if (withoutAttention.length > 0) {
      attention.push(...conditonBacteria);
    // } else {
    //   const existingBacteria = conditonBacteria.find(
    //     ({ name }) => !attention.some((b) => b.name === name && !b.condition)
    //   );
    //   if (existingBacteria) {
    //     existingBacteria.condition = condition;
    //   }

    // }
  
  }); 


  if (attention.length < 2) {
    attention.push(
      ...summary.keyBacteria.bacteria
        .filter(({ action }) => action === BacteriaAttentionAction.maintain)
        // .slice(1, 3 - attention.length)
    );
  }

  return attention;
};

export const ReportBacteriaAttentionUtils = {
  pick,
};
